import React, { Component } from "react";
import { connect } from 'react-redux';
import { Icon, Select } from 'antd';
const { Option } = Select;
import i18next from 'i18next';
import lockr from 'lockr';
import moment from 'moment';
import Link from '../UI/Link/Link';

import { StoreState, UserState } from './../../types';

import { FooterStyle } from "./FooterStyle";

type FooterProps = {
	user: UserState;
	t: i18next.TFunction;
	i18n: i18next.i18n;
}

class Footer extends Component<FooterProps> {
	state = {
		showChat: false
	};

	openChat = (e: any) => {
		e.preventDefault();

		if ((window as any).$crisp && (window as any).$crisp.is("chat:closed")) {
			(window as any).$crisp.push(['do', 'chat:open']);
		}

	};

	onLanguageChange = (name: string, value: string) => {
		this.props.i18n.changeLanguage(value);
		lockr.set('locale', value);
		moment.locale(value);
	};

	render() {
		const language = this.props.i18n.language.substring(0, 2) ? this.props.i18n.language.substring(0, 2) : 'nl';

		return (
			<footer className="c-footer" style={{backgroundColor: 'rgba(244,244,244,1)', color: '#000' }}>
				<div className="o-container">
						<div className="c-footer__meta">
							<span>© 2021. All Rights Reserved To - <span style={{fontWeight: "bold"}}>The Wake University</span></span>
						</div>
				</div>
			</footer>
		);
	}
}
export const mapDispatchToProps = {
};

export function mapStateToProps({ user }: StoreState.All) {
	return {
		user,
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
